/*
 * Copyright (c) 2023 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import classNames from "classnames";
import { changeLanguage, getAvailableLanguageMap, i18nInstance } from "i18n/i18n";
import { LanguageSelectorIcon } from "../icons/LanguageSelectorIcon";
// import { Select } from "components/base/_common";
import "./LanguageSelector.scss";
import { default as ReactSelect } from "react-select";
import { OptionType } from "components/base/_common/Select/Select";

interface Props {
  className?: string;
}

type SelectOption = OptionType;

export const LanguageSelector = (props: Props) => {
  const { className } = props;
  const currentLanguage = i18nInstance.language;
  const languageMap = getAvailableLanguageMap();

  const options = Object.keys(languageMap).map(
    (languageCode): SelectOption => ({
      label: languageMap[languageCode],
      value: languageCode,
    })
  );
  const current = options.find((option) => option.value === currentLanguage) as SelectOption;

  return (
    <div className={classNames("languageSelector", className)}>
      <LanguageSelectorIcon className="languageSelector-icon" />
      <div className="languageSelector-dropdown">
        <ReactSelect
          classNamePrefix="language-select"
          options={options}
          onChange={(option: SelectOption) => changeLanguage(option.value)}
          isMulti={false}
          defaultValue={current}
          menuPlacement="top"
        />
      </div>
    </div>
  );
};
